export const parseNumber = (value) => {
  return value.replace(/\$\s?|(,*)/g, '');
};